import http from '../../Common/api';
import generateQueryParamsUrl from '../../Common/utils/queryParamsGenerator';

import { agenciesUrl, partnersUrl, aggregatorsUrl } from './constants';
import {
  normalizeAgencies,
  normalizePartners,
  normalizeAgencyCreation,
  normalizeError,
  normalizeCredentials,
  normalizeNodeOptions,
  normalizeCredentialsPayload,
  normalizeUpdateAgencyPayload,
  normalizeSaveCredentialError,
} from './normalizers';

const createAgency = async payload => {
  try {
    const response = await http.post(agenciesUrl, normalizeAgencyCreation(payload));

    return response;
  } catch (error) {
    return normalizeError(error);
  }
};

const fetchSaveCredential = async values => {
  try {
    const { agencyId, aggregatorID } = values;
    const requestUrl = `${agenciesUrl}${agencyId}/aggregator/${aggregatorID}/production-credentials/`;
    const normalizedPayload = normalizeCredentialsPayload(values);
    await http.put(requestUrl, normalizedPayload);

    return { ok: true };
  } catch (error) {
    return { ok: false, error: normalizeSaveCredentialError(error) };
  }
};

const getAgenciesReports = async (filters = {}) => {
  try {
    const searchBy = generateQueryParamsUrl(agenciesUrl, filters);
    const agenciesReports = await http.get(searchBy);

    return normalizeAgencies(agenciesReports);
  } catch (error) {
    return normalizeAgencies({});
  }
};

const getAgenciesCredentials = async agencyId => {
  try {
    const credentials = await http.get(`${agenciesUrl}${agencyId}/aggregators/`);

    return normalizeCredentials(credentials);
  } catch (error) {
    return normalizeCredentials({});
  }
};

const getPartners = async () => {
  try {
    const partners = await http.get(partnersUrl);

    return normalizePartners(partners);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getNodeOptions = async () => {
  try {
    const nodeOptions = await http.get(aggregatorsUrl);

    return normalizeNodeOptions(nodeOptions);
  } catch (error) {
    return [{ label: 'Please Select...', value: '' }];
  }
};

const getAgenciesFilterOptions = async () => Promise.all([getPartners()]);

const fetchUpdateAgency = async ({ agencyId, values }) => {
  try {
    await http.put(`${agenciesUrl}${agencyId}/`, normalizeUpdateAgencyPayload(values));

    return { ok: true };
  } catch (error) {
    return { ok: false, error: normalizeError(error) };
  }
};

export {
  getAgenciesReports,
  getAgenciesFilterOptions,
  createAgency,
  getAgenciesCredentials,
  getNodeOptions,
  fetchSaveCredential,
  fetchUpdateAgency,
};
